import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnDG: CultureInfo = {
  name: 'en-DG',
  displayName: 'English (Diego Garcia)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-DG',
  parent: CultureInfoEn
};
